import React, { FC } from "react";
import { Svg, G, Polygon, Path } from "react-native-svg";

const WaterPiece: FC = () => {
  return (
    <>
      <Svg viewBox="0 0 1567 1547.42">
        <G scale={0.8} translate={[156.7, 140]}>
          <Polygon
            stroke="#00B3FF"
            strokeWidth="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            points="
		1372.599,1028.798 783.5,8.447 194.401,1028.798 783.5,1538.973 	"
          />
          <Path
            fill="#00B3FF"
            stroke="#00B3FF"
            strokeWidth="20"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M675.15,1286.832c0.007-0.006,58.928,16.889,58.928,16.889l31.181,4.265l31.915-0.034l60.46-5.334l60.323-15.205l55.447-25.041
			l51.592-36.204l36.56-35.967l36.271-47.217l29.384-53.309l19.399-56.398l8.837-61.123l-1.809-54.729l-5.264-29.89l-5.387-20.553
			l-6.423-19.898l-19.961-57.209l-21.645-56.602l-39.146-84.305l-27.612-53.929l-21.492-43.151l-22.105-42.848l-28.733-52.009
			l-22.537-39.419l-22.487-39.449l-6.892-12.887l-6.975-13.116l-11.002-18.957l-11.77-15.576l-30.125-24.086l-36.004-11.189
			l-11.454-0.513l-29.582,5.554l-27.88,15.644l-23.082,24.167l-6.133,9.482l-29.431,51.61l-29.232,51.726l-41.331,72.157
			l-56.897,104.375l-48.262,101.298l-43.107,103.933l-17.701,56.852l-8.797,60.289l3.191,66.057l18.108,65.438l26.232,54.752
			l34.625,51.381l41.984,44.019l51.044,36.756L675.15,1286.832z M627.646,1160.958l-34.38-33.075l-27.154-37.496l-26.539-53.398
			l-12.92-47.181l-2.222-42.503l5.185-40.972l15.633-52.353l40.282-97.33l45.007-94.924l56.783-104.439l41.563-72.563l29.232-51.726
			l29.431-51.61l2.773-3.887l3.315-3.368l3.596-2.349l1.55-0.408l0.884,0.131l1.635,0.682l2.333,1.532l3.668,3.445l2.921,3.807
			l11.201,19.784l5.692,10.835l5.703,10.501l22.191,38.96l22.267,38.933l28.314,51.219l22.578,43.84l21.962,44.129l26.705,52.022
			l34.179,73.348l21.238,55.498l19.602,56.099l7.512,24.407l3.138,13.457l2.16,13.639l1.453,38.65l-4.625,37.401l-13.463,43.509
			l-20.319,39.253l-33.384,44.586l-44.803,40.512l-50.118,27.258l-53.171,14.992l-53.249,4.619l-30.927-0.793l-29.834-6.536
			l-28.297-9.08l-40.504-17.54L627.646,1160.958z"
          />

          <Polygon
            fill="#00B3FF"
            stroke="#00B3FF"
            strokeWidth="20"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            points="
			1000.248,944.642 991.611,921.511 975.436,902.567 963.357,895.883 949.607,893.865 947.125,894.063 932.094,898.518 
			919.528,908.007 912.265,919.186 908.388,930.382 905.754,942.172 898.026,970.864 889.341,994.572 875.28,1015.824 
			868.843,1021.965 855.231,1037.869 850.05,1051.71 849.842,1066.514 854.492,1079.521 859.112,1086.442 870.274,1096.663 
			884.404,1102.353 897.69,1102.926 912.008,1098.924 923.545,1092.857 946.312,1076.185 966.438,1055.192 981.063,1032.639 
			991.84,1007.047 1001.676,958.248 1001.253,953.264 1000.854,948.944 		"
          />
        </G>
      </Svg>
    </>
  );
};

export { WaterPiece };
